export const TRACK_VISIT_SESSION_COOKIE = 'track_visit_session_id'
export const TRACK_VISIT_SESSION_EXPIRE_MINUTES = 30
export const VISIT_TTL_MILLISECONDS =
  TRACK_VISIT_SESSION_EXPIRE_MINUTES * 60 * 1000
